import {
    FormControlLabel, Checkbox, FormControl, MenuItem, InputLabel, Select,
    Paper, Table, Grid, TextField, InputAdornment, ListItemText, Dialog, DialogTitle, DialogContent,
} from '@mui/material';
import { Chip } from '@mui/material';
import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import axiosInstance from '../../lib/axios';
import { Box, Typography, CircularProgress, Tooltip, IconButton, Button } from '@mui/material';
import { usePermissions } from '../../GlobalFunction/userPermissions';
import { useSelector } from 'react-redux';
import { selectGlobalProperty } from '../../redux/propertySlice';
import { useNavigate, useLocation } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import HomeIcon from '@mui/icons-material/Home';
import DownloadIcon from '@mui/icons-material/Download';
import CalendarReport from './CalendarReport';
import CloseIcon from '@mui/icons-material/Close';

import { getYojnaMasterdropdata, getShiftMasterdropdata, getRoomMasterdropdata } from '../../Api/PropertyMst/Api';
import PDFReport, { generateAndDownloadPDF } from './PDFReport';
import { generateAndDownloadCalendarPDF } from './PDFReport';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const GREEN = '#70ad47';
const HEADER_BG = '#f2f2f2';
const BORDER = '#c9c9c9';

const Weektaskreport = () => {
    const [rowData, setRowData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isExporting, setIsExporting] = useState(false);
    const UserId = sessionStorage?.getItem('UserId');
    const permissions = usePermissions("Promocode Master");
    const [yojna, setYojna] = useState([]);
    const [shiftData, setShiftData] = useState([]);
    const [propertyData, setPropertyData] = useState([]);
    const [AddRec, setAddRec] = useState("0");
    const [selectedYojnas, setSelectedYojnas] = useState([]);
    const [activeDays, setActiveDays] = useState([]);
    const gridRef = useRef();
    const navigate = useNavigate();
    const globalProperty = useSelector(selectGlobalProperty);
    const location = useLocation();
    const [openDialog, setOpenDialog] = useState(false);
    const [calendarData, setCalendarData] = useState([]);

    const generateCalendarPDFReport = () => {
        if (rowData.length === 0) {
            toast.warning('No data to print');
            return;
        }

        try {

            const workstations = [...new Set(rowData.map(item => item.HkWrkStnName))].filter(Boolean);

            const tasks = [...new Set(rowData.map(item => item.HkTaskName))].filter(Boolean);

            const fromDate = formData.FromDate;
            const toDate = formData.ToDate;

            const propertyName = propertyData.find(p => p.id.toString() === formData.Property)?.name || 'Property';


            const shiftName = shiftData.find(s => s.id.toString() === formData.Shift)?.name || 'Shift';


            generateAndDownloadCalendarPDF({
                rowData,
                workstations,
                tasks,
                fromDate,
                toDate,
                propertyName,
                shiftName,
                selectedYojnas,
                yojnaData: yojna,
                days: DAYS,
                fileName: `Task_Calendar_${fromDate}_to_${toDate}.pdf`
            });

            toast.success('Calendar PDF downloaded successfully');
        } catch (error) {
            console.error('PDF generation error:', error);
            toast.error('Error generating calendar PDF');
        }
    };



    const handleOpen = () => {
        setOpenDialog(true);
    };

    const closeDialog = () => {
        setOpenDialog(false);
    };

    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const getMaxDate = () => {
        const maxDate = new Date();
        maxDate.setDate(maxDate.getDate() + 30);
        const year = maxDate.getFullYear();
        const month = String(maxDate.getMonth() + 1).padStart(2, '0');
        const day = String(maxDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        if (location.state && location.state.rowData) {
            setFormData({
                Property: location.state.propertyId || '',
                Shift: location.state.shiftId || '',
                Yojna: '',
                FromDate: location.state.fromDate || todayDate,
                ToDate: location.state.toDate || todayDate,
            });

            if (location.state.selectedYojnas) {
                setSelectedYojnas(location.state.selectedYojnas);
            }

            if (location.state.rowData) {
                fetchReportData(location.state.rowData);
            }
        }
    }, [location.state]);

    const todayDate = getTodayDate();
    const maxDate = getMaxDate();

    const [formData, setFormData] = useState({
        Property: '',
        Shift: '',
        Yojna: '',
        FromDate: todayDate,
        ToDate: todayDate,
    });

    const determineActiveDays = (data) => {
        if (!data || data.length === 0) return [];

        const activeDaySet = new Set();

        data.forEach(row => {
            DAYS.forEach(day => {
                if (row[day] === "1") {
                    activeDaySet.add(day);
                    activeDaySet.add(`${day}A`);
                }
                else if (row[`${day}A`] === "1") {
                    activeDaySet.add(`${day}A`);
                }
            });
        });

        const sortedDays = Array.from(activeDaySet).sort((a, b) => {
            const order = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat',
                'SunA', 'MonA', 'TueA', 'WedA', 'ThuA', 'FriA', 'SatA'];
            return order.indexOf(a) - order.indexOf(b);
        });

        return sortedDays;
    };

    useEffect(() => {
        fetchYojnaData();
        fetchShiftData();
        fetchPropertyData();
    }, []);

    const fetchYojnaData = async () => {
        try {
            const response = await getYojnaMasterdropdata({
                Flag: "",
                YojanaId: 1
            });
            if (response?.data?.Status === 0) {
                const dropdownItems = response.data.Data.map((item) => ({
                    id: item.YojanaId,
                    name: item.YojanaName,
                }));
                setYojna(dropdownItems);
            }
        } catch (error) {
            toast.error("Error fetching yojna data");
        }
    };

    const fetchShiftData = async () => {
        try {
            const response = await getShiftMasterdropdata();
            if (response?.data?.Status === 0) {
                const dropdownItems = response.data.Data.map((item) => ({
                    id: item.ShiftId,
                    name: item.ShiftName,
                }));
                setShiftData(dropdownItems);
                if (dropdownItems.length > 0) {
                    setFormData(prev => ({
                        ...prev,
                        Shift: dropdownItems[0].id.toString()
                    }));
                }
            }
        } catch (error) {
            toast.error("Error fetching shift data");
        }
    };

    const fetchPropertyData = async () => {
        try {
            const response = await getRoomMasterdropdata({
                Flag: "",
                UserId: UserId,
            });
            if (response?.data?.Status === 0) {
                const dropdownItems = response.data.Data?.map((item) => ({
                    id: item.PropId,
                    name: item.Name,
                }));
                setPropertyData(dropdownItems);

                if (globalProperty) {
                    setFormData(prev => ({ ...prev, Property: globalProperty.toString() }));
                } else if (dropdownItems.length > 0) {
                    setFormData(prev => ({ ...prev, Property: dropdownItems[0].id.toString() }));
                }
            }
        } catch (error) {
            toast.error("Error fetching property data");
        }
    };

    const fetchReportData = async (rowDataFromDoubleClick = null) => {
        setIsLoading(true);
        try {
            const isFromDoubleClick = rowDataFromDoubleClick !== null;
            let propId, shiftId, fromDate, toDate;

            if (isFromDoubleClick) {
                propId = parseInt(rowDataFromDoubleClick.PropId) || parseInt(location.state?.propertyId);
                shiftId = parseInt(rowDataFromDoubleClick.ShiftId) || parseInt(location.state?.shiftId);
                fromDate = rowDataFromDoubleClick.WrkRecvDt || formData.FromDate;
                toDate = rowDataFromDoubleClick.WrkRecvDt || formData.ToDate;
            } else {
                propId = parseInt(formData.Property);
                shiftId = parseInt(formData.Shift);
                fromDate = formData.FromDate;
                toDate = formData.ToDate;
            }

            const payload = {
                PropId: propId || parseInt(formData.Property),
                YojanaId: 1,
                ShiftId: shiftId || parseInt(formData.Shift),
                HkWrkAreaId: 1,
                StrHkTaskId: "",
                StrYojanaId: selectedYojnas.length > 0 ? selectedYojnas.join(',') : "",
                StrHkWrkAreaId: "",
                WrkRecvDt: fromDate,
                WrkRecvToDt: toDate,
                Flag: isFromDoubleClick ? "TaskRptDtDetails" : ""
            };

            const response = await axiosInstance.post(
                'MstYojana/RetriveGetTrnWrkRecvTaskDtWise',
                payload
            );

            if (response.data.Status === 0 && response.data.Data?.length > 0) {
                const formattedData = response.data.Data.map((item, index) => ({
                    ...item,
                    RowNum: index + 1,
                    QCComments: item.QCComments || '',
                    QCPoints: item.QCPoints || 0,
                    Performance: item.Performance || '',
                    ToDoList: item.ToDoList || ''
                }));

                // Determine which days have "1" values
                const activeDayColumns = determineActiveDays(formattedData);
                setActiveDays(activeDayColumns);

                setRowData(formattedData);
            } else {
                setRowData([]);
                setActiveDays([]);
                toast.info(response.data.Message || 'No data found for selected criteria');
            }
        } catch (error) {
            toast.error('Error fetching report data');
            setRowData([]);
            setActiveDays([]);
        } finally {
            setIsLoading(false);
        }
    };


    const floorData = useMemo(() => {
        const floorsMap = {};

        rowData.forEach((row) => {
            const floorName = row.HkWrkStnName || 'Unassigned';
            const roomId = row.HkWrkAreaId ?? row.HkWrkAreaName;
            const roomName = row.HkWrkAreaName || '-';

            if (!floorsMap[floorName]) floorsMap[floorName] = {};
            if (!floorsMap[floorName][roomId]) {
                floorsMap[floorName][roomId] = { roomName, activeDays: new Set() };
            }

            DAYS.forEach((day) => {
                if (row[`${day}A`] === '1') {
                    floorsMap[floorName][roomId].activeDays.add(day);
                }
            });
        });

        return Object.entries(floorsMap)
            .map(([floorName, roomsObj]) => {
                const rooms = Object.entries(roomsObj)
                    .map(([roomId, data]) => ({ roomId, ...data }))
                    .sort((a, b) =>
                        a.roomName.localeCompare(b.roomName, undefined, { numeric: true })
                    );
                return { floorName, rooms };
            })
            .sort((a, b) => a.floorName.localeCompare(b.floorName, undefined, { numeric: true }));
    }, [rowData]);

    const dateRange = useMemo(() => {
        if (!formData.FromDate || !formData.ToDate) return [];
        const dates = [];
        const current = new Date(formData.FromDate);
        const end = new Date(formData.ToDate);
        while (current <= end) {
            dates.push(new Date(current));
            current.setDate(current.getDate() + 1);
        }
        return dates;
    }, [formData.FromDate, formData.ToDate]);

    const formatDateLabel = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('en-US', { month: 'short' });
        const year = String(date.getFullYear()).slice(-2);
        return `${day}-${month}-${year}`;
    };

    const exportToExcel = () => {
        if (rowData.length === 0) {
            toast.warning('No data to export');
            return;
        }

        setIsExporting(true);

        try {
            const lines = [];

            floorData.forEach((floor) => {
                const header = [floor.floorName, ...floor.rooms.map(r => r.roomName), 'Day Total'];
                lines.push(header.join(','));

                const monthTotals = floor.rooms.map(() => 0);

                dateRange.forEach((date) => {
                    const dayName = DAYS[date.getDay()];
                    let dayTotal = 0;
                    const rowCells = floor.rooms.map((room, idx) => {
                        const active = room.activeDays.has(dayName);
                        if (active) {
                            dayTotal++;
                            monthTotals[idx]++;
                        }
                        return active ? '1' : '';
                    });
                    lines.push([formatDateLabel(date), ...rowCells, dayTotal].join(','));
                });

                lines.push(['Month Total', ...monthTotals, monthTotals.reduce((a, b) => a + b, 0)].join(','));
                lines.push('');
            });

            const csvContent = lines.join('\n');
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', `Daily_Task_Report_${formData.FromDate}_to_${formData.ToDate}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            toast.success('Exported successfully');
        } catch (error) {
            toast.error('Error exporting data');
        } finally {
            setIsExporting(false);
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleYojnaMultiSelect = (event) => {
        const { value } = event.target;
        setSelectedYojnas(typeof value === 'string' ? value.split(',') : value);
    };

    const handleClearFilters = () => {
        setFormData(prev => ({ ...prev }));
    };

    useEffect(() => {
        const prevBodyOverflow = document.body.style.overflowX;
        const prevHtmlOverflow = document.documentElement.style.overflowX;
        document.body.style.overflowX = 'hidden';
        document.documentElement.style.overflowX = 'hidden';
        return () => {
            document.body.style.overflowX = prevBodyOverflow;
            document.documentElement.style.overflowX = prevHtmlOverflow;
        };
    }, []);

    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: '96vw',
                minWidth: 0,
                height: '90vh',
                padding: '10px',
                backgroundColor: 'rgb(249, 249, 249)',
                position: 'relative',
                overflowX: 'hidden',
                boxSizing: 'border-box',
            }}
        >
            <ToastContainer />
            <Box
                sx={{
                    backgroundColor: "#ffffff",
                    padding: { xs: "8px 12px", sm: "10px 16px" },
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    alignItems: "center",
                    gap: { xs: 1, sm: 1.5 },
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
                    borderRadius: "12px",
                    margin: "10px auto",
                    width: '100%',
                    maxWidth: '100%',
                    boxSizing: 'border-box',
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    WebkitOverflowScrolling: 'touch',
                    '&::-webkit-scrollbar': { height: '6px' },
                    '&::-webkit-scrollbar-thumb': { backgroundColor: '#ccc', borderRadius: '4px' },
                }}
            >

                <Breadcrumbs
                    aria-label="breadcrumb"
                    separator="›"
                    sx={{
                        fontSize: { xs: "12px", sm: "13px", md: "14px" },
                        display: "flex",
                        alignItems: "center",
                        flexShrink: 0,
                        whiteSpace: "nowrap",
                    }}
                >
                    <Link
                        underline="hover"
                        color="#635bff"
                        sx={{ cursor: "pointer", fontWeight: "500", display: "flex", alignItems: "center" }}
                        onClick={() => navigate('/dashboard')}
                    >
                        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        <Box component="span">Home</Box>
                    </Link>
                    <Link
                        underline="hover"
                        color="#635bff"
                        sx={{ cursor: "pointer", fontWeight: "500", display: "flex", alignItems: "center" }}
                        onClick={() => navigate('/reports/dailysummaryreport')}
                    >
                        Report
                    </Link>
                    <Typography color="text.primary" sx={{ fontWeight: "500", whiteSpace: "nowrap" }}>
                        Task Report
                    </Typography>
                </Breadcrumbs>


                <Box sx={{ width: '1px', height: '28px', backgroundColor: '#e0e0e0', flexShrink: 0, mx: 0.5 }} />

                <Box
                    sx={{
                        display: "flex",
                        flexWrap: "nowrap",
                        gap: 1,
                        alignItems: "center",
                        flexShrink: 0,
                    }}
                >
                    <FormControl
                        variant="filled"
                        size="small"
                        sx={{ width: { xs: "110px", sm: "130px", md: "180px" }, flexShrink: 0 }}
                        className="custom-textfield"
                    >
                        <InputLabel>Property</InputLabel>
                        <Select name="Property" value={formData.Property} onChange={handleInputChange}>
                            {propertyData.map((item) => (
                                <MenuItem key={item.id} value={item.id.toString()}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl
                        variant="filled"
                        size="small"
                        sx={{ width: { xs: "95px", sm: "110px", md: "150px" }, flexShrink: 0 }}
                        className="custom-textfield"
                    >
                        <InputLabel>Shift</InputLabel>
                        <Select name="Shift" value={formData.Shift} onChange={handleInputChange}>
                            {shiftData.map((item) => (
                                <MenuItem key={item.id} value={item.id.toString()}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl
                        variant="filled"
                        size="small"
                        sx={{ width: { xs: "120px", sm: "140px", md: "150px" }, flexShrink: 0 }}
                        className="custom-textfield"
                    >
                        <InputLabel id="yojna-multi-label">Yojna Name</InputLabel>
                        <Select
                            labelId="yojna-multi-label"
                            multiple
                            value={selectedYojnas}
                            onChange={handleYojnaMultiSelect}
                            renderValue={(selected) => {
                                if (selected.length === 0) return <em>Select Yojna(s)</em>;

                                const selectedNames = selected.map(id => {
                                    const item = yojna.find(item => item.id.toString() === id.toString());
                                    return item?.name || id;
                                });

                                if (selectedNames.length > 2) {
                                    return (
                                        <Tooltip title={selectedNames.join(', ')} arrow>
                                            <span>{`${selectedNames.slice(0, 2).join(', ')} +${selectedNames.length - 2} more`}</span>
                                        </Tooltip>
                                    );
                                }
                                return selectedNames.join(', ');
                            }}
                            MenuProps={MenuProps}
                        >
                            {yojna.map((item) => (
                                <MenuItem key={item.id} value={item.id.toString()}>
                                    <Checkbox checked={selectedYojnas.indexOf(item.id.toString()) > -1} sx={{ padding: "2px" }} />
                                    <ListItemText primary={item.name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <TextField
                        label="From Date"
                        type="date"
                        name="FromDate"
                        value={formData.FromDate}
                        onChange={handleInputChange}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ max: maxDate, min: '2020-01-01' }}
                        variant="filled"
                        size="small"
                        sx={{ width: { xs: "125px", sm: "135px", md: "145px" }, flexShrink: 0 }}
                        className="custom-textfield"
                    />

                    <TextField
                        label="To Date"
                        type="date"
                        name="ToDate"
                        value={formData.ToDate}
                        onChange={handleInputChange}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ max: maxDate, min: formData.FromDate }}
                        variant="filled"
                        size="small"
                        sx={{ width: { xs: "125px", sm: "135px", md: "145px" }, flexShrink: 0 }}
                        className="custom-textfield"
                    />

                    <Button
                        variant="contained"
                        onClick={fetchReportData}
                        disabled={isLoading}
                        size='small'
                        sx={{ bgcolor: '#635bff', '&:hover': { bgcolor: '#5248cc' }, textTransform: 'none', flexShrink: 0, whiteSpace: 'nowrap' }}
                    >
                        {isLoading ? 'Loading..' : 'Search'}
                    </Button>

                    <Tooltip title='Export to Excel' arrow>
                        <Button
                            variant="contained"
                            onClick={exportToExcel}
                            disabled={isExporting || rowData.length === 0}
                            startIcon={<DownloadIcon />}
                            size='small'
                            sx={{ bgcolor: '#2e7d32', '&:hover': { bgcolor: '#1b5e20' }, textTransform: 'none', flexShrink: 0, whiteSpace: 'nowrap' }}
                        >
                            {isExporting ? 'Exporting...' : 'Export'}
                        </Button>
                    </Tooltip>

                    {/* <Tooltip title='Check Calendar' arrow>
                        <Button
                            variant="contained"
                            size='small'
                            onClick={handleOpen}
                            sx={{ bgcolor: '#635bff', ":hover": { bgcolor: '#635bff' }, textTransform: 'none', flexShrink: 0, whiteSpace: 'nowrap' }}
                        >
                            Calendar
                        </Button>
                    </Tooltip> */}

                    {/* <Tooltip title='Print Pdf' arrow>
            <Button disabled={isExporting || rowData.length === 0} variant="contained" size='small' onClick={generateCalendarPDFReport} sx={{ bgcolor: '#7bc440', ":hover": { bgcolor: '#45a111' }, textTransform: 'none' }}>Print</Button>
        </Tooltip> */}

                    <Tooltip title='Previous Page' arrow>
                        <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                            <IconButton
                                onClick={() => navigate('/reports/dailysummaryreport')}
                                size='small'
                                sx={{
                                    backgroundColor: '#635bff',
                                    borderRadius: '50%',
                                    width: 35,
                                    height: 35,
                                    '&:hover': { backgroundColor: '#635bff' },
                                    boxShadow: 3,
                                }}
                            >
                                <ArrowBackIcon sx={{ color: 'white' }} />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>
            </Box>


            <Box
                sx={{
                    height: 'calc(95% - 100px)',
                    width: '94vw',
                    maxWidth: '100%',
                    minWidth: 0,
                    margin: '10px auto',
                    position: 'relative',
                    backgroundColor: '#ffffff',
                    borderRadius: '12px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
                    overflowX: 'auto',
                    overflowY: 'auto',
                    padding: 0,
                    boxSizing: 'border-box',
                    WebkitOverflowScrolling: 'touch',

                }}
            >
                {isLoading ? (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 10,
                            textAlign: 'center',
                        }}
                    >
                        <CircularProgress size="3rem" sx={{ color: '#635bff' }} />
                        <Typography sx={{ marginTop: 2, color: '#635bff', fontWeight: 'bold' }}>
                            Loading data...
                        </Typography>
                    </Box>
                ) : floorData.length === 0 ? (
                    <Box sx={{ textAlign: 'center', py: 6 }}>
                        <Typography color="text.secondary">No data to display</Typography>
                    </Box>
                ) : (
                    <Box sx={{ padding: { xs: '8px 16px', sm: '12px 16px' }, boxSizing: 'border-box' }}>
                        {floorData.map((floor) => (
                            <FloorCalendarBlock
                                key={floor.floorName}
                                floor={floor}
                                dateRange={dateRange}
                                formatDateLabel={formatDateLabel}
                            />
                        ))}
                    </Box>
                )}

                {rowData.length > 0 && (
                    <Box sx={{
                        fontSize: '14px',
                        color: 'black',
                        mt: 1,
                        padding: { xs: '0 16px 8px', sm: '0 16px 12px' },
                    }}>
                        Total Records: <b>{rowData.length}</b>
                    </Box>
                )}
            </Box>

            <Dialog open={openDialog} onClose={closeDialog} maxWidth="lg" fullWidth>
                <DialogTitle
                    id="calendar-report-dialog"
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1 }}
                >
                    Calendar Report
                    <CloseIcon
                        onClick={closeDialog}
                        sx={{ cursor: 'pointer', color: 'red', '&:hover': { color: 'red' } }}
                        aria-label="close"
                    />
                </DialogTitle>

                <DialogContent dividers>
                    <CalendarReport
                        shift={shiftData}
                        yojna={yojna}
                        property={propertyData}
                        selectedProperty={formData.Property}
                        selectedShift={formData.Shift}
                        selectedYojnas={selectedYojnas}
                        fromDate={formData.FromDate}
                        toDate={formData.ToDate}
                    />
                </DialogContent>
            </Dialog>

        </Box>
    );
};


const FloorCalendarBlock = ({ floor, dateRange, formatDateLabel }) => {
    const { floorName, rooms } = floor;

    const monthTotals = rooms.map((room) => {
        let count = 0;
        dateRange.forEach((date) => {
            if (room.activeDays.has(DAYS[date.getDay()])) count++;
        });
        return count;
    });

    const grandMonthTotal = monthTotals.reduce((a, b) => a + b, 0);

    return (
        <Box sx={{ mb: 3, maxWidth: '100%' }}>
            <table
                style={{
                    borderCollapse: 'separate',
                    borderSpacing: 0,
                    fontSize: '12px',
                    width: '100%',
                    tableLayout: 'auto',
                }}
            >
                <thead>
                    <tr>
                        <th style={{ ...cellStyle(HEADER_BG, true, 'left'), ...stickyColStyle, ...stickyHeaderStyle, zIndex: 3 }}>
                            {floorName}
                        </th>
                        {rooms.map((room) => (
                            <th key={room.roomId} style={{ ...cellStyle(HEADER_BG, true, 'center'), ...stickyHeaderStyle }}>
                                {room.roomName}
                            </th>
                        ))}
                        <th style={{ ...cellStyle(HEADER_BG, true, 'center'), ...stickyHeaderStyle }}>Day Total</th>
                    </tr>
                </thead>
                <tbody>
                    {dateRange.map((date) => {
                        const dayName = DAYS[date.getDay()];
                        let dayTotal = 0;
                        const cells = rooms.map((room) => {
                            const active = room.activeDays.has(dayName);
                            if (active) dayTotal++;
                            return (
                                <td
                                    key={room.roomId}
                                    style={cellStyle(active ? GREEN : '#fff', false, 'center')}
                                />
                            );
                        });
                        return (
                            <tr key={date.toISOString()}>
                                <td style={{ ...cellStyle('#fff', false, 'left'), ...stickyColStyle }}>
                                    {formatDateLabel(date)}
                                </td>
                                {cells}
                                <td style={cellStyle('#fff', true, 'center')}>{dayTotal}</td>
                            </tr>
                        );
                    })}
                    <tr>
                        <td style={{ ...cellStyle(HEADER_BG, true, 'left'), ...stickyColStyle }}>
                            Month Total
                        </td>
                        {monthTotals.map((total, idx) => (
                            <td key={idx} style={cellStyle(HEADER_BG, true, 'center')}>
                                {total}
                            </td>
                        ))}
                        <td style={cellStyle(HEADER_BG, true, 'center')}>{grandMonthTotal}</td>
                    </tr>
                </tbody>
            </table>
        </Box>
    );
};


const stickyColStyle = {
    position: 'sticky',
    left: 0,
    zIndex: 1,
};

const stickyHeaderStyle = {
    position: 'sticky',
    top: 0,
    zIndex: 2,
};

const cellStyle = (bg, bold, align) => ({
    border: `1px solid ${BORDER}`,
    padding: '3px 10px',
    backgroundColor: bg,
    fontWeight: bold ? 600 : 4200,
    textAlign: align,
    minWidth: '4px',
    whiteSpace: 'nowrap',
});

export default Weektaskreport;